import L from 'leaflet';

export const RVRMarker = (color, id = 0, size = [36, 60]) => {
    const scaleFactor = size[0] / 36;
    const iconSize = [size[0], size[1]];
    const iconAnchor = [size[0] / 2, size[1] / 2];
    const fontSize = 30 * scaleFactor;
    const textY = 60 * scaleFactor;

    let textElement = ''; // Initialize the text element as an empty string

    if (id > 0) {
        // Add the <text> element if id > 0
        textElement = `<text x="52.61" y="${textY}" font-size="${fontSize}" fill="#000000" text-anchor="middle">${id}</text>`;
    }

    const svgMarkup = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105.23 135.47">
      <path style="fill:${color}" d="m52.61,127.75C32.93,103.97-4.82,49.75,7.39,22.86,12.78,11.01,27.99,5,52.61,5s39.84,6.01,45.22,17.86c12.21,26.88-25.54,81.11-45.22,104.89Z"/>
      <path d="m52.61,10c22.48,0,36.17,5.02,40.67,14.93,5.53,12.16-.77,34.19-17.72,62.02-8.05,13.21-16.88,25.05-22.95,32.76-6.08-7.7-14.91-19.54-22.95-32.76C12.71,59.11,6.42,37.09,11.94,24.93c4.5-9.9,18.18-14.93,40.67-14.93m0-10c-118.38,0,0,135.47,0,135.47,0,0,118.38-135.47,0-135.47h0Z"/>
      ${textElement} <!-- Insert the text element -->
    </svg>
  `;

    return L.divIcon({
        html: svgMarkup,
        className: "rvr-marker",
        iconSize: iconSize,
        iconAnchor: iconAnchor,
    });
};
